/* Advice only: never reads or writes configurator state, price, variant or cart. */
(() => {
  function init(scope) {
    scope.querySelectorAll('[data-ea-compare]').forEach((select) => {
      if (select.dataset.eaReady) return;
      select.dataset.eaReady = 'true';
      const region = select.closest('.ea__compare');
      const update = () => region.querySelectorAll('[data-ea-model]').forEach((cell) => {
        cell.classList.toggle('ea__alternative', cell.dataset.eaModel === select.value);
      });
      select.addEventListener('change', update);
      update();
      region.classList.add('ea__compare--interactive');
    });
    scope.querySelectorAll('[data-ea-finder]').forEach((root) => {
      if (root.dataset.eaReady) return;
      root.dataset.eaReady = 'true';
      const choices = root.querySelectorAll('input[type="radio"]');
      const panels = root.querySelectorAll('[data-ea-answer]');
      const update = () => {
        const selected = root.querySelector('input[type="radio"]:checked');
        if (!selected) return;
        panels.forEach((panel) => { panel.hidden = panel.dataset.eaAnswer !== selected.value; });
      };
      choices.forEach((choice) => choice.addEventListener('change', update));
      root.querySelector('[data-ea-choices]').hidden = false;
      update();
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
